import { useCallback } from "react"
import { useComputed, useSignal } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"

import { useToast } from "@hooks"
import { WEBBACK_V2_API } from "@constants"
import { isLoadingCommonFilters, userData } from "@signals"
import { adminScrapingDataReviewFiltersSubmitted, adminScrapingDataReviewPercentageData, adminScrapingDataReviewTableData } from "../@signals"


export default function useAdminScrapingDataReviewSubmits() {
    const { showToast } = useToast()
    const adminScrapingDataReviewIsEmpty = useSignal(false)

    const adminScrapingDataReviewShowTable = useComputed(() => !isLoadingCommonFilters.value && adminScrapingDataReviewTableData.value.length)

    const handleSubmitFilters = useCallback(values => {
        adminScrapingDataReviewIsEmpty.value = false
        return getSubmit(`${WEBBACK_V2_API}/admin/scraping-data-review/raw-data/${userData.value.customerID}/${values.retailer.toString()}/${values.currentSingleDate}`).then(res => {
            if (!res.table.length) adminScrapingDataReviewIsEmpty.value = true
            else {
                adminScrapingDataReviewFiltersSubmitted.value = {
                    customerID: userData.value.customerID,
                    retailer: values.retailer.toString(),
                    singleDate: values.currentSingleDate
                }
                adminScrapingDataReviewTableData.value = res.table
                
                const percentageData = {}
                for (const key in res) {
                    if (key.startsWith("percentage")) {
                        percentageData[key] = res[key]
                    }
                }
                adminScrapingDataReviewPercentageData.value = percentageData
            }
        }).catch(() => {
            showToast.error()
            adminScrapingDataReviewIsEmpty.value = true
            adminScrapingDataReviewTableData.value = []
        })
    })

    return {
        adminScrapingDataReviewIsEmpty,
        adminScrapingDataReviewShowTable,

        handleSubmitFilters
    }
}